
import { provide, inject, ref, Ref, computed, ComputedRef } from '@vue/composition-api';
import Vue from 'vue';

const UserSymbol = Symbol()

type UserContex = {
    username: Ref<string>;
    accessToken: Ref<string>;
    refreshToken: Ref<string>;
    isStaff: Ref<boolean>;
    isTutor: Ref<boolean>;
    currentCourse: Ref<string>;
    loggedIn: ComputedRef<boolean>;
    setCurrentCourse: (newCourseId: string) => void;
    updateStorage: (info: any) => void;
    getUserToken: () => void;
    destroyToken: () => void;
};

export const useUserServiceProvide = () => {
    const username = ref<string>('');
    const accessToken = ref<string>('');
    const refreshToken = ref<string>('');
    const isStaff = ref<boolean>(false);
    const isTutor = ref<boolean>(false);
    const currentCourse = ref<string>('');

    const loggedIn = computed(() => {
        return accessToken.value != undefined && accessToken.value != ''
    })

    const token = localStorage.getItem('accessToken') as string
    if (token) {
        Vue.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
        const userString = decodeURIComponent(escape(window.atob(token.split('.')[1])))
        const newUsername = JSON.parse(userString)['name']
        accessToken.value = token
        refreshToken.value = localStorage.getItem('refreshToken') as string
        username.value = newUsername
    }

    const updateStorage = ({ access, refresh, newUsername, roles }: any) => {
        accessToken.value = access
        refreshToken.value = refresh
        username.value = newUsername
        isStaff.value = roles.includes('ADMIN')
        isTutor.value = roles.includes('TUTOR')
    }

    const destroyToken = () => {
        username.value = ''
        accessToken.value = ''
        refreshToken.value = ''
        isStaff.value = false
        isTutor.value = false
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
    }

    const getUserToken = () => {
        Vue.prototype.$axios.get('getToken/')
          .then((req: any) => {
            if(req.data['access'] && req.data['refresh']) {
              localStorage.setItem('accessToken', req.data['access'])
              localStorage.setItem('refreshToken', req.data['refresh'])
              const userString = decodeURIComponent(escape(window.atob(req.data['access'].split('.')[1])))
              const user = JSON.parse(userString)
              updateStorage({
                access: req.data['access'],
                refresh: req.data['refresh'],
                newUsername: user['name'],
                roles: user['roles']
              })
            } else {
              if (username.value || isStaff.value || loggedIn) {
                destroyToken()
              }
            }
          })
    }

    const setCurrentCourse = (newCourseId: string) => {
        currentCourse.value = newCourseId
    }

    provide(UserSymbol, {
        username,
        accessToken,
        refreshToken,
        isStaff,
        isTutor,
        currentCourse,
        loggedIn,
        updateStorage,
        setCurrentCourse,
        getUserToken,
        destroyToken
    });
};

export const useUserServiceInject = () => {
    const userContex = inject<UserContex>(UserSymbol);

    if (!userContex) {
        throw new Error(`loginContex must be used after useLoginServiceProvide`);
    }

    return userContex;
}